import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from './services/auth.service';
import { Router } from '@angular/router';

@Injectable()

export class UnauthorizedAccessInterceptor implements HttpInterceptor {

  constructor(private authservice: AuthService, private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse && err.status === 401) {
          this.authservice.destroyStorage();
          if (!this.router.url.includes('/login')) {
            this.router.navigate(['/login']);
          }
        }
        return throwError(() => err);
      })
    );
  }
}

export const HttpClientUnAuthorizedService = { 
  provide: HTTP_INTERCEPTORS, 
  useClass: UnauthorizedAccessInterceptor, 
  multi: true 
};

